import { render } from "./viewformtemplate.vue?vue&type=template&id=0c5220a0"
import script from "./viewformtemplate.js?vue&type=script&lang=js"
export * from "./viewformtemplate.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__